import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'material-ui';

export const BackButton = (props) => {

    const {
        link,
        style,
        variant,
        color,
        className,
        touched,
        onClick
    } = props;

    return (
        <Button
            variant={variant}
            color={color}
            className={className}
            component={Link}
            to={link}
            style={style}
            touched={touched === true ? "true" : "false"}
            onClick={onClick}
        >
            {touched ? 'Cancel' : 'Back'}
        </Button>
    )
}


// WEBPACK FOOTER //
// ./src/components/buttons/BackButton.jsx